import * as React from 'react';

import Text from 'crehana-ui/Text';
import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

import CopyButton from 'Shared/CopyButton';

const Affiliate: React.FC<Partial<CourseCardProps>> = props => {
  const { affiliateCommission, affiliateUrl } = props;

  return (
    <div
      className="hidden md:flex justify-between items-center mb-0 md:mb-16"
      css={`
        & svg {
          display: none !important;
        }
      `}
    >
      <Text type="body4">{`Comisión: $${affiliateCommission}`}</Text>
      <CopyButton
        textToCopy={affiliateUrl}
        wrapperStyles={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Text type="link" color="secondary-main">
          Copiar link
        </Text>
      </CopyButton>
    </div>
  );
};

export default Affiliate;
